import axios from 'axios'
import { Toast } from 'antd-mobile';
import Cookies from 'js-cookie'
import { wxAuthorize, getQueryString, hex2bin, getUrlParams, jumpApp, isWeChat } from '../utils/utils'
import { global } from '../config/index'
import wx from 'weixin-js-sdk'

import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom'

const defaultAxiosConf = {
  baseURL: global.domain,
  timeout: 5000,
  headers: {
    Accept: 'application/json'
  }
}

const setCookieParams = () => {
  let from_openid = getQueryString('from_openid');
  let activity_id = getQueryString('activity_id');
  let is_new = getQueryString('is_new');
  let openid = getQueryString('openid');

  if (openid) {
    Cookies.set('openid', openid, {
      expires: 1 / 12 //1day
    })
  }

  if (from_openid) {
    Cookies.set('from_openid', from_openid, {
      expires: 1 //1day
    })
  }

  if (activity_id) {
    Cookies.set('activity_id', activity_id, {
      expires: 1 //1day
    })
  }

  if (is_new) {
    Cookies.set('is_new', is_new, {
      expires: 1 //1day
    })
  }
}

const _request = (params = {}, fn = () => { }) => {
  if (params.method === 'get') {
    params.params = {
      ...params.params
    }
  } else {
    params.data = {
      ...params.data
    }
  }

  return axios({ ...defaultAxiosConf, ...params })
    .then(res => {
      const { status, msg } = res.data
      // console.log(res);
      if (status) {
        fn(false)
        return msg
      } else {
        throw String(msg || '网络错误')
        // return []
      }
    })
    .catch(err => {
      fn(false)
      //TODO 屏蔽掉网络错误弹窗

      if (String(err).indexOf('Network Error') <= 0 && String(err) != '网络错误') {
        // Toast.offline(String(err || '网络错误'), 1)
        console.log(String(err || '网络错误'));
      }
      throw err
    })
}

const signLogin = (params) => {
  let loginSign = getQueryString('sign');

  let sign = (params.params && params.params.sign) ? params.params.sign : false
  sign = sign || (params.data && params.data.sign) ? params.data.sign : false

  if (loginSign && loginSign.length > 0) {
    sign = hex2bin(loginSign)
    // signValid({sign: loginSign}).then((res)=>{
    Cookies.set('sign', sign, {
      expires: 1 //1day
    })
    // })
  }

  sign = sign || Cookies.get('sign')
  if (!sign) {
    if (isWeChat() === 5) {
      wx.miniProgram.navigateTo({
        url: '/pages/login/authorize/authorize'
      })
    } else {
      jumpApp({ opentype: 'login', openvar: '' })
      return;
    }
  }

  if (params.method === 'get') {
    params.params = {
      ...params.params,
      sign: sign
    }
  } else {
    params.data = {
      ...params.data,
      sign: sign
    }
  }
  return params
}

const openidLogin = (params) => {
  setCookieParams()
  let openid = (params.params && params.params.openid) ? params.params.openid : false
  openid = openid || (params.data && params.data.openid) ? params.data.openid : false
  openid = openid || Cookies.get('openid')
  if (!openid) {
    wxAuthorize();//去登录
    return;
  }
  if (params.method === 'get') {
    params.params = {
      ...params.params,
      openid: openid
    }
  } else {
    params.data = {
      ...params.data,
      openid: openid
    }
  }
  return params
}

const setUserInfo = () => {
  let nickname = getQueryString('nickname');
  let sso_id = getQueryString('sso_id');

  if (nickname) {
    Cookies.set('nickname', nickname, {
      expires: 1 //1day
    })
  }

  if (sso_id) {
    Cookies.set('sso_id', sso_id, {
      expires: 1 //1day
    })
  }
}

export default (param) => {
  let pathname = window.location.pathname
  if (pathname.indexOf('/carrier') >= 0 || pathname.indexOf('/share') >= 0 || pathname.indexOf('/lg') >= 0) {
    if (!param.data.h5IsLogin || param.data.h5IsLogin !== 1) {
      param = signLogin(param)
    }
  } else if (pathname.indexOf('/fission/') >= 0) {
    param = openidLogin(param)
  } else {
    // param = openidLogin(param)
  }

  const typeRes = typeof param

  let urlRequest = getUrlParams()
  if (param.method === 'get') {
    param.params = {
      ...Object.assign(param.params, urlRequest)
    }
  } else {
    param.data = {
      ...Object.assign(param.data, urlRequest)
    }
  }
  setUserInfo()
  // if (typeRes === 'function') {
  //   param(true)
  //   return (obj) => _request(obj, param)
  // }
  if (typeRes === 'object' && typeRes !== null) return _request(param)
}
